<script>
const conditionList = (list) => {
  return list.filter(({ condition }) => {
    if (condition) return condition()
    return true
  })
}

export default {
  components: {},
  filters: {
    // genderFilter
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    petList: {
      type: Array,
      default: () => [],
    },
    isOrderDetail: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'reservation',
      validator(value) {
        return ['reservation', 'prepaid'].includes(value)
      },
    },
    memberInfo: {
      type: Object,
      default: () => {
        return {
          gender: '',
          fullName: '',
        }
      },
    },
  },
  data() {
    return {
      // taiwanCitys,
      // taxTypeMap,
      // carrierTypeMap,
      // submitData: Object.assign({}, initData()),
      // tryingStoreMember: false,
      // activeTab: 'information',
      // editBasicInfoEnabled: false,
      // editInvoiceEnabled: false,
      // // 地址
      // addressMode: 'billing',
      // visibleDialogAddress: false,
      // tryingSaveAddress: false,
      // memberOrderType:'order',
      relationQuestionDialog: false,
      viewList: Object.freeze(
        conditionList([
          {
            text: `${this.$t('reserve.CLIENT')}資訊`,
            icon: 'eye',
            alias: 'information',
          },
          {
            text: '歷史紀錄',
            icon: 'history',
            alias: 'service',
          },
          {
            text: '新增服務紀錄',
            icon: 'plus',
            alias: 'addService',
            condition: () => {
              return !!this.defaultValue.id && this.type === 'reservation'
            },
          },
        ])
      ),
    }
  },
  computed: {
    /** ********** 寵物相關 start ************/
    selectPetCont() {
      if (!this.petList.length) return
      const cont = this.petList.find((item) => item.id === this.defaultValue.petId)
      const gender = cont.gender ? (cont.gender === 'male' ? `${this.$t('sex.Male')}` : `${this.$t('sex.Female')}`) : ''
      this.$emit('selectedPetInfo', cont)
      return `
        <span class="text-secondary fw-medium">${cont.name} ${gender}</span> ${cont.categoryTitle}/${cont.sizeTitle}
        `
    },
    selectPetDetailCont() {
      if (!this.defaultValue?.pet) return
      const pet = this.defaultValue?.pet
      const gender = pet.gender ? (pet.gender === 'male' ? `${this.$t('sex.Male')}` : `${this.$t('sex.Female')}`) : ''
      return `<span class="text-secondary fw-medium">${pet.name} ${gender}</span> ${pet.categoryTitle}/${pet.sizeTitle}`
    },
    /** ********** 寵物相關 end ************/
    productName() {
      const format = {
        reservation: '選擇預約服務',
        prepaid: `購買${this.$t('prepaid.BASE')}`,
      }
      return format[this.type]
    },
    /**
     * @description 為輸入姓名或性別不可打開選擇寵物畫面
     */
    disableSelectPetBtn() {
      if (!this.memberInfo.fullName || !this.memberInfo.gender) {
        return true
      }
      return false
    },
  },
  watch: {
    // memberInfo: {
    //   handler(val) {
    //     this.submitData = cloneDeep({
    //       ...val,
    //       phone: val.phoneNumber,
    //       merchantNote: val.merchantNote.replace(/<br\s\/>/g, ''),
    //       extraInfos: val.extraInfos
    //       ?? {
    //         extraInfoPhone: [extraInfoPhone],
    //         extraInfoEmergency: [extraInfoEmergency]
    //       }
    //     })
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    goToDetail(alias) {
      const data = {
        alias,
        isShowPetList: false,
      }
      this.$emit('toDetail', data)
    },
    openSelectPet() {
      if (this.disableSelectPetBtn) {
        this.$confirm('請先至會員資訊輸入性別及姓名', '提醒', {
          confirmButtonText: '確定',
          showCancelButton: false,
          type: 'warning',
          center: true,
        })
        return
      }
      this.$emit('onSelect')
    },
  },
}
</script>
<template>
  <div :class="$style.OrderPetInfo">
    <template v-if="!defaultValue.pet && !defaultValue.petId && !isOrderDetail">
      <p class="color-text-primary text-center mt-0">
        {{ `請先選擇${$t('reserve.CLIENT')}，才可${productName || '進行下一步'}` }}</p
      >
      <el-button class="is-round is-fullwidth" style="margin-top: 0" @click="openSelectPet">
        選擇{{ $t('reserve.CLIENT') }}
      </el-button>
    </template>
    <template v-else>
      <div class="inline-between align-items-center" style="margin-top: 0">
        <div v-if="!isOrderDetail" class="my-2" v-html="selectPetCont"></div>
        <div v-else class="my-2" v-html="selectPetDetailCont"></div>
        <!-- 新增 -->
        <!-- <el-button v-if="!isOrderDetail" type="text" class="" siez="mini" @click="$emit('seeRelatedQ')">
          <BaseIcon class="text-primary" icon-style="fal" name="fa-messages-question" />
          查看相關問答
        </el-button> -->
        <el-button v-if="!isOrderDetail && !$store.getters['modifyOrder/isModified']" type="text" size="mini" @click="openSelectPet">
          <BaseIcon name="edit" class="text-primary" />
          重選{{ $t('reserve.CLIENT') }}
        </el-button>
        <!-- 編輯 -->
        <!-- <div v-if="isOrderDetail" @click="relationQuestionDialog = true"><BaseIcon class="text-primary" icon-style="fal" name="fa-messages-question"/> 查看相關問答</div> -->
      </div>
      <el-divider class="my-2"></el-divider>
      <div class="infoList__view">
        <ul class="viewList__item list-unstyled d-flex w-100">
          <li v-for="(item, index) in viewList" :key="index" class="viewList__item">
            <el-button class="w-100 isSecondaryText viewList__itemBtn" type="text" @click="goToDetail(item.alias)">
              <BaseIcon :name="item.icon" />
              <span>{{ item.text }}</span>
            </el-button>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>
<style lang="scss" module>

.OrderPetInfo {
  :global {
    .viewList {
      &__item {
        flex-grow: 1;
        font-size: 0.75rem;

        &Btn {
          @include max-md {
            font-size: 12px;
            color: #404040;
          }
        }

        svg {
          font-size: 1.25rem;
          color: $color-primary;
          vertical-align: text-top;

          @include max-md {
            font-size: 1rem;
            vertical-align: bottom;
          }
        }

        &:not(:last-child) {
          position: relative;

          &:before {
            content: '';
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 50%;
            width: 1px;
            background: #e5e7eb;
          }
        }
      }
    }
  }
}
</style>
